/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
define(["require", "exports", "azure-devops-ui/Status", "azure-devops-ui/TooltipEx", "azure-devops-ui/Util", "react"], function (require, exports, Status_1, TooltipEx_1, Util_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ResourceStatus = /** @class */ (function (_super) {
        __extends(ResourceStatus, _super);
        function ResourceStatus() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ResourceStatus.prototype.render = function () {
            return (React.createElement("div", { className: Util_1.css("kube-status-container", this.props.className) }, this.props.toolTipText ?
                React.createElement(TooltipEx_1.Tooltip, { text: this.props.toolTipText, overflowOnly: false, showOnFocus: true }, this._getStatus()) : this._getStatus()));
        };
        ResourceStatus.prototype._getStatus = function () {
            return (React.createElement("span", { className: "res-status" },
                this.props.statusProps &&
                    React.createElement(Status_1.Status, __assign({}, this.props.statusProps, { size: this.props.statusSize || "16" /* m */ })),
                React.createElement("div", { className: "description-padding" },
                    this.props.statusDescription &&
                        React.createElement("span", { className: "kube-status-desc" }, this.props.statusDescription),
                    this.props.customDescription)));
        };
        return ResourceStatus;
    }(React.Component));
    exports.ResourceStatus = ResourceStatus;
});
